import { Box, Button, Card, Heading, Paragraph } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { captureEvent } from '../../../../../services/event-capture';
import { reset as floatPlanReset } from '../../../../../services/store/modules/float-plan';
import {
  reset as planReset,
  selectPlanIsLoggingOn,
} from '../../../../../services/store/modules/plan';
import SheetLayout, {
  SheetBody,
} from '../../../../layouts/SheetLayout/SheetLayout';
import { invertedTick, ReactSvg } from '../../../../shared/vector-images';

const PlanCompletePage: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoggingOn = useSelector(selectPlanIsLoggingOn);

  const handlerPlanReset = () => {
    // reset floatPlan and plan state
    dispatch(floatPlanReset());
    dispatch(planReset());
  };

  const handleOnCloseClick = () => {
    captureEvent({
      type: 'plan: click close created plan',
      payload: {},
    });
    handlerPlanReset();
    history.push('/maps');
  };

  return (
    <SheetLayout heading="" showMenuBar={false}>
      <SheetBody>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mx="auto"
          mt="0"
          mb="30px"
        >
          <ReactSvg
            toDisplay={invertedTick()}
            options={{
              fillColor: '#0AAD2E',
            }}
            width={110}
            height={110}
          />
        </Box>

        <Card bg="transparent" textAlign="center">
          <Card.Head>
            <Card.DeprecatedHeading>
              <Box py={2}>
                <Heading level={5}>
                  {isLoggingOn ? 'You are logged on with' : 'Plan created'}
                </Heading>
                {isLoggingOn && <Heading level={5}>Marine Rescue WA</Heading>}
              </Box>
              <Paragraph px={2} py={2}>
                {isLoggingOn
                  ? 'If your intentions change or you are delayed, update your plan in DECKEE or use radio or phone to notify Marine Rescue WA.'
                  : 'If your intentions change or you are delayed, update your plan in DECKEE to notify your emergency contacts.'}
              </Paragraph>
            </Card.DeprecatedHeading>
          </Card.Head>
        </Card>

        <Button.Group wide>
          <Button onClick={handleOnCloseClick} outlined>
            Close
          </Button>
        </Button.Group>
      </SheetBody>
    </SheetLayout>
  );
};

export default PlanCompletePage;
